import React, { Component } from 'react'

import '../styles/LogoContainer.css'

class LogoContainer extends Component {
  render () {
    return (
      <div className='LogoContainer'>
        <div className='navbar-brand'>
          <img src='/images/inline/logo-hpe.png' alt='HPE Logo' style={{ marginRight: 40 }} />
          <img src='/images/inline/logo-microsoft.png' style={{ position: 'relative', top: 10 }} alt='Microsoft Logo' />
          <img src='/images/inline/logo-intel-white.png' alt='Intel Logo' style={{ width: 70, marginLeft: 40 }} />
        </div>
      </div>
    )
  }
}

export default LogoContainer



// WEBPACK FOOTER //
// ./src/components/LogoContainer.js